<template>
    <ItemMenuWrapper :label="label" v-slot="{ inputId }">
        <div class="flex align-items-center">
            <Checkbox :id="inputId" :modelValue="modelValue" @update:modelValue="handleUpdate" :binary="true" />
            <label class="ml-2">{{ modelValue ? 'Ativado' : 'Desativado' }}</label>
        </div>
    </ItemMenuWrapper>
</template>

<script setup>
import ItemMenuWrapper from './ItemMenuWrapper.vue';
import { defineProps, defineEmits } from 'vue';

defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
    label: {
        type: String,
        required: true,
    },
});

const emit = defineEmits(['update:modelValue']);

const handleUpdate = (value) => {
    emit('update:modelValue', value);
};
</script>
